import { barcodeLabelTemplateSchema } from "@redotech/redo-inventory-common/barcode-label-builder/barcode-label-definition";
import * as z from "zod";

export const saveBarcodeLabelTemplate = {
  name: "saveBarcodeLabelTemplate" as const,
  input: z.object({ template: barcodeLabelTemplateSchema }),
  output: z.object({ template: barcodeLabelTemplateSchema }),
};
